module.exports = __webpack_public_path__ + "img/volvo_fqsc.31bfb75a.svg";